import { Collector, CollectorAction, CollectorBillingPeriodData } from '@/domain/collectors/collector';
import { BillingType } from '@/domain/invoices/invoice';
import { backendApi } from '../backendApi';
import { ApiResponse, PaginatedResponse } from '@/domain';

export interface CollectorPaymentsParams {
  collectorId?: string;
  periodStart: string;
  periodEnd?: string;
  page?: number;
  limit?: number;
  status?: string;
  serviceType?: string;
  offeringId?: string;
}

export const collectorsApi = {
  getAllCollectors: (filters?: { status?: string; name?: string; }) =>
    backendApi.get<ApiResponse<Collector[]>>(`/api/v1/collectors`, {
      params: filters,
    }).then((res) => res.data.data),

  getCollector: (id: string) =>
    backendApi.get<ApiResponse<Collector>>(`/api/v1/collectors/${id}`).then((res) => res.data.data),

  createCollector: (data: Partial<Collector>) =>
    backendApi.post<ApiResponse<Collector>>(`/api/v1/collectors`, data).then((res) => res.data.data),

  updateCollector: (id: string, data: Partial<Collector>) =>
    backendApi.put<ApiResponse<Collector>>(`/api/v1/collectors/${id}`, data).then((res) => res.data.data),

  deleteCollector: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/collectors/${id}`).then((res) => res.data.data),

  getCollectorPayments: ({
    collectorId,
    periodStart,
    periodEnd,
    page,
    limit,
    status,
    serviceType,
    offeringId
  }: CollectorPaymentsParams) => backendApi.get<ApiResponse<PaginatedResponse<CollectorBillingPeriodData>>>(`/api/v1/data/collectors/periods`, {
    params: { collectorId, periodStart, periodEnd, page, limit, status, serviceType, offeringId },
  }
  ).then((res) => res.data.data),

  modifyPaymentsByCollector: (
    collectorId: string,
    paymentIds: string[],
    operation: CollectorAction,
    billingType: BillingType
  ) => backendApi.put<ApiResponse<{ updatedCount: number }>>(
    `/api/v1/collectors/${collectorId}/payments`,
    { paymentIds, operation, billingType },
    { timeout: 120000 }
  ).then((res) => res.data.data),
}
